import axios from "@axios" //eslint-disable-line

export default {
    /*
     * main channels API
     */
    getChannels() {
        return axios.get('/channels')
    },
    addChannel(data) {
        return axios.post('/channels', data)
    },
    getChannel(uuid) {
        return axios.get(`/channels/${uuid}`)
    },
    updateChannel(uuid, payload) {
        return axios.put(`/channels/${uuid}`, payload)
    },
}
